import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

export const leftProject = createAsyncThunk(
  "leftProject/leftProject",
  async (projectId, { rejectWithValue }) => {
    try {
      console.log("Left Project Action - ProjectId:", projectId);

      if (!projectId) {
        throw new Error("ProjectId is required");
      }

      const response = await api.patch("/projects/leftProject", { projectId });
      console.log("Left Project Action - Response:", response);
      return response.data;
    } catch (error) {
      console.error("Left Project Action - Full Error:", error);
      console.error("Left Project Action - Error Response:", error.response);
      console.error("Left Project Action - Error Request:", error.request);
      console.error("Left Project Action - Error Config:", error.config);
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
